// import {
//     Button,
//     CircularProgress,
//     Dialog,
//     DialogActions,
//     DialogContent,
//     DialogTitle,
//     TextField,
//     Typography
// } from "@mui/material";

// import { useEffect, useState, useRef } from "react";
// import portalpaymentlink from "../../services/portalpaymentlink";
// import Swal from "sweetalert2";

// function CreateQueueModal({ open, campaignId, onClose, onSuccess }) {
//     const [links, setLinks] = useState("");
//     const [loading, setLoading] = useState(false);
//     const isMounted = useRef(false);

//     useEffect(() => {
//         isMounted.current = true;

//         return () => {
//             isMounted.current = false;
//         }
//     }, []);

//     useEffect(() => {
//         if (open) {
//             setLinks("");
//             setLoading(false);
//         }
//     }, [open]);

//     const handleSubmit = async () => {
//         try {
//             setLoading(true);

//             const formattedLinks = links.split("\n").map(x => x.trim()).filter(Boolean);

//             let postdata = {
//                 "campaignId": campaignId,
//                 "postLinks": formattedLinks
//             };

//             const createQueueResp = await portalpaymentlink.createPaymentQueue(postdata);

//             if (createQueueResp['success']) {
//                 onSuccess(createQueueResp['processed'], createQueueResp['skipped']);
//             }
//             else {
//                 Swal.fire({
//                     title: 'Create Link Error',
//                     text: createQueueResp['message'],
//                     icon: 'error'
//                 });
//             }
//         }
//         catch (error) {
//             Swal.fire({
//                 title: 'Create Link Error',
//                 text: error?.message,
//                 icon: 'error'
//             });
//         }
//         finally {
//             if (isMounted.current) {
//                 setLoading(false);
//             }
//         }
//     }

//     const totalLinks = links.split("\n").map(x => x.trim()).filter(Boolean).length;

//     return (
//         <Dialog
//             open={open}
//             maxWidth="md"
//             fullWidth
//         >
//             <DialogTitle
//                 sx={{
//                     fontWeight: 600,
//                     fontSize: 16
//                 }}
//             >
//                 Create Payment Queue (Maximum 10 links allowed at a time)
//             </DialogTitle>

//             <DialogContent>
//                 <TextField
//                     multiline
//                     rows={10}
//                     fullWidth
//                     value={links}
//                     onChange={(event) => setLinks(event.target.value)}
//                     placeholder={`https://instagram.com/reel/abc\nhttps://instagram.com/reel/xyz`}
//                 />

//                 {/* Footer Section */}
//                 <Typography
//                     fontSize={14}
//                     my={2}
//                 >
//                     Links Detected: {totalLinks}
//                 </Typography>
//             </DialogContent>

//             <DialogActions
//                 sx={{
//                     columnGap: 1
//                 }}
//             >
//                 <Button
//                     onClick={onClose}
//                     variant="outlined"
//                     sx={{
//                         fontSize: 14,
//                         textTransform: 'capitalize',
//                         color: '#ee4c3a'
//                     }}
//                 >
//                     Cancel
//                 </Button>

//                 <Button
//                     variant="contained"
//                     onClick={handleSubmit}
//                     sx={{
//                         py: 0.9,
//                         textTransform: 'capitalize'
//                     }}
//                     disabled={loading || totalLinks === 0 || totalLinks > 10}
//                 >
//                     {
//                         loading ?
//                             <CircularProgress
//                                 sx={{
//                                     color: '#FFFFFF'
//                                 }}
//                                 size={16}
//                             />
//                             :
//                             <Typography
//                                 fontSize={14}
//                             >
//                                 Generate Preview
//                             </Typography>
//                     }
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     )
// }

// export default CreateQueueModal;

// Updated Logic
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tab,
    Tabs,
    TextField,
    Typography
} from "@mui/material";

import { useEffect, useMemo, useRef, useState } from "react";
import portalpaymentlink from "../../services/portalpaymentlink";
import Swal from "sweetalert2";

const TABS = {
    REGULAR: 0,
    ADVANCE: 1,
    RESULT: 2
};

function CreateQueueModal({ open, campaignId, onClose, onSuccess }) {
    const [activeTab, setActiveTab] = useState(TABS.REGULAR);

    const [postLinks, setPostLinks] = useState("");
    const [profileLinks, setProfileLinks] = useState("");

    const [loading, setLoading] = useState(false);

    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (open) {
            setActiveTab(TABS.REGULAR);
            setPostLinks("");
            setProfileLinks("");
            setLoading(false);
        }
    }, [open]);

    const currentInput = activeTab === TABS.REGULAR ? postLinks : profileLinks;

    const totalLinks = useMemo(() => {
        return currentInput
            .split("\n")
            .map(x => x.trim())
            .filter(Boolean).length;
    }, [currentInput]);

    const handleRegularPayment = async () => {
        const formattedLinks = postLinks
            .split("\n")
            .map(x => x.trim())
            .filter(Boolean);

        const postdata = {
            campaignId,
            postLinks: formattedLinks
        };

        const createQueueResp = await portalpaymentlink.createPaymentQueue(postdata);

        if (createQueueResp.success) {
            onSuccess(createQueueResp.processed, createQueueResp.skipped);
            return;
        }

        Swal.fire({
            title: "Create Link Error",
            text: createQueueResp.message,
            icon: "error"
        });
    };

    const handleAdvancePayment = async () => {
        const formattedProfiles = profileLinks
            .split("\n")
            .map(x => x.trim())
            .filter(Boolean);

        console.log(formattedProfiles);

        const response = await portalpaymentlink.createAdvanceQueue({
            campaignId,
            profileLinks: formattedProfiles
        });

        if (response?.success) {
            onSuccess(response.processed, response.skipped);
            return;
        }
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);

            if (activeTab === TABS.REGULAR) {
                await handleRegularPayment();
            }
            else if (activeTab === TABS.ADVANCE) {
                await handleAdvancePayment();
            }
        }
        catch (error) {
            Swal.fire({
                title: "Error",
                text: error?.message,
                icon: "error"
            });
        }
        finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle
                sx={{
                    fontWeight: 600,
                    fontSize: 16
                }}
            >
                Create Payment Queue
            </DialogTitle>

            <Tabs
                value={activeTab}
                onChange={(e, value) => setActiveTab(value)}
                variant="fullWidth"
            >
                <Tab label="Using Post Link" />
                <Tab label="Using Profile Link" />
                <Tab label="Result" disabled />
            </Tabs>

            <DialogContent sx={{ mt: 2 }}>
                {activeTab === TABS.REGULAR && (
                    <TextField
                        multiline
                        rows={10}
                        fullWidth
                        value={postLinks}
                        onChange={(e) => setPostLinks(e.target.value)}
                        placeholder={`https://instagram.com/reel/abc\nhttps://instagram.com/reel/xyz`}
                    />
                )}

                {activeTab === TABS.ADVANCE && (
                    <TextField
                        multiline
                        rows={10}
                        fullWidth
                        value={profileLinks}
                        onChange={(e) => setProfileLinks(e.target.value)}
                        placeholder={`https://instagram.com/username1\nhttps://instagram.com/username2`}
                    />
                )}

                <Typography
                    fontSize={14}
                    my={2}
                >
                    Links Detected: {totalLinks}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ columnGap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        fontSize: 14,
                        textTransform: "capitalize",
                        color: "#ee4c3a"
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading || totalLinks === 0 || totalLinks > 10}
                    sx={{
                        py: 0.9,
                        textTransform: "capitalize"
                    }}
                >
                    {loading ? (
                        <CircularProgress
                            size={16}
                            sx={{ color: "#fff" }}
                        />
                    ) : (
                        <Typography fontSize={14}>
                            {activeTab === TABS.REGULAR
                                ? "Generate Preview"
                                : "Create Advance Queue"}
                        </Typography>
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateQueueModal;